import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { PricingStrategy } from "../base/pricing.strategy";
import { Overdoor } from "../../entities/overdoor";

export class OverdoorPricingStrategy extends PricingStrategy {
    public getPrices(overdoor: ReactiveComponent): PriceResult {
        return {
            price: this.calculateComponentsPriceForType(
                overdoor as Overdoor,
                CostDealType,
            ),
            priceB2C: this.calculateComponentsPriceForType(
                overdoor as Overdoor,
                B2CDealType,
            ),
            priceB2B: this.calculateComponentsPriceForType(
                overdoor as Overdoor,
                B2BDealType,
            ),
        };
    }

    private calculateComponentsPriceForType(
        overdoor: Overdoor,
        dealType: string,
    ) {
        const children = overdoor.components;

        return children.reduce((total, child) => {
            const sum = child.sum.getSystemPrice(dealType).getValue();

            return total + sum;
        }, 0);
    }
}
